import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../../components/Header";
import {
  Box,
  Button,
  TextField,
  Typography,
  useMediaQuery,
  Snackbar,
  Alert,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useSelector } from "react-redux";
import {
  selectCurrentToken,
  selectSponserID,
} from "../../features/auth/authSlice";

const userSchema = yup.object().shape({
  title: yup.string().required("required"),
  description: yup.string().required("required"),
  price: yup.number().required("required"),
  quantity: yup.number().required("required"),
});

const Index = () => {
  const location = useLocation();
  const prop = location.state;
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [initialValues, setInitialValues] = useState({
    title: "",
    description: "",
    price: "",
    quantity: "",
  });
  const [productImages, setProductImages] = useState({} as any);
  const [isOpen, setIsOpen] = useState(false);
  const sponserId = useSelector(selectSponserID);
  const token = useSelector(selectCurrentToken);

  const handleFormSubmit = async (values: any) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("price", values.price);
    formData.append("quantity", values.quantity);
    Object.keys(productImages).forEach((image) => {
      formData.append("productImages", productImages[image]);
    });
    formData.append("landingPageId", prop.id);
    formData.append("sponserId", sponserId);
    const response = await fetch(
      process.env.REACT_APP_ENV === "local"
        ? "/sponser/addProduct"
        : process.env.REACT_APP_BACKEND_API + "/sponser/addProduct",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );
    if (response.status === 201) {
      setIsOpen(true);
    }
  };

  return (
    <div className="ml-5 mt-[100px]">
      <Header title="Products" subtitle="Add Products" />
      <div className="flex justify-center w-[100%]">
        <Typography variant="h4" className="underline">
          {prop.title}
        </Typography>
      </div>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={userSchema}
      >
        {/* @ts-ignore */}
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Box
                display={"grid"}
                gap="30px"
                gridTemplateColumns={"repeat(4, minmax(0,1fr))"}
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type={"text"}
                  label="Title"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    setInitialValues({
                      ...initialValues,
                      title: e.target.value,
                    });
                  }}
                  value={initialValues.title}
                  name="title"
                  error={!!touched.title && !!errors.title}
                  helperText={touched.title && errors.title}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type={"text"}
                  label="Description"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    setInitialValues({
                      ...initialValues,
                      description: e.target.value,
                    });
                  }}
                  value={initialValues.description}
                  name="description"
                  error={!!touched.description && !!errors.description}
                  helperText={touched.description && errors.description}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type={"number"}
                  label="Price"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    setInitialValues({
                      ...initialValues,
                      price: e.target.value,
                    });
                  }}
                  value={initialValues.price}
                  name="price"
                  error={!!touched.price && !!errors.price}
                  helperText={touched.price && errors.price}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type={"number"}
                  label="Quantity"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    setInitialValues({
                      ...initialValues,
                      quantity: e.target.value,
                    });
                  }}
                  value={initialValues.quantity}
                  name="quantity"
                  error={!!touched.quantity && !!errors.quantity}
                  helperText={touched.quantity && errors.quantity}
                  sx={{ gridColumn: "span 2" }}
                />
                <div className="w-[100%]">
                  <input
                    type="file"
                    multiple
                    accept="image/jpeg"
                    onChange={(e) => setProductImages(e.target.files)}
                  />
                </div>
              </Box>
              <Box display="flex" justifyContent={"start"} mt="20px">
                <Button type="submit" color="secondary" variant="contained">
                  Add Product
                </Button>
              </Box>
              <Snackbar
                open={isOpen}
                autoHideDuration={6000}
                onClose={() => setIsOpen(false)}
                message="Note archived"
              >
                <Alert
                  onClose={() => setIsOpen(false)}
                  severity="success"
                  sx={{ width: "100%" }}
                >
                  Product Added Successfully!
                </Alert>
              </Snackbar>
            </form>
          );
        }}
      </Formik>
      <div className="mt-5">
        <Link to={"/viewProducts"} state={{ _id: prop.id }}>
          <Button variant="contained">View Products</Button>
        </Link>
      </div>
    </div>
  );
};

export default Index;
